import styled from 'styled-components';

export const PageHeadingWrapper = styled.div`
    padding: 0 100px;
    padding-top: 180px;
`